/* unplugin-vue-components disabled */import { render } from "./AppFeatures.vue?vue&type=template&id=23b651db&scoped=true"
import script from "./AppFeatures.vue?vue&type=script&lang=js"
export * from "./AppFeatures.vue?vue&type=script&lang=js"

import "./AppFeatures.vue?vue&type=style&index=0&id=23b651db&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23b651db"]])

export default __exports__